/* Favorites tabs.

   Lives in its own asset rather than in theme.js. theme.js is one long shared
   file and this section shipped while the header was being rebuilt in the same
   tree; a separate file cannot lose an edit to a concurrent write.

   Progressive enhancement, in this order:

     1. The server renders every panel, visible. No JavaScript means a visitor
        scrolls through all the categories. Nothing is unreachable.
     2. This script hides all but the first panel and lights up the first tab.
        Only now does the tab strip mean anything, and only now is it wired.

   Doing it the other way round, marking panels hidden server side, would leave
   a no-JavaScript visitor staring at buttons that do nothing with most of the
   content sealed behind them.

   Keyboard follows the ARIA tabs pattern: arrows move, Home and End jump to the
   ends, and roving tabindex keeps the strip to a single tab stop so Tab moves
   past the group rather than through every button in it. */
(function () {
  'use strict';

  var sections = document.querySelectorAll('[data-favorites]');
  if (!sections.length) return;

  Array.prototype.forEach.call(sections, function (root) {
    var tabs = root.querySelectorAll('[data-fav-tab]');
    var panels = root.querySelectorAll('[data-fav-panel]');
    if (!panels.length) return;

    // One panel and no strip is the single-category case. Leave it alone: it is
    // already correct as plain server rendered markup.
    if (tabs.length < 2) return;

    function panelFor(tab) {
      var want = tab.getAttribute('data-fav-index');
      for (var i = 0; i < panels.length; i++) {
        if (panels[i].getAttribute('data-fav-index') === want) return panels[i];
      }
      return null;
    }

    function select(tab, moveFocus) {
      Array.prototype.forEach.call(tabs, function (t) {
        var on = t === tab;
        t.setAttribute('aria-selected', on ? 'true' : 'false');
        t.setAttribute('tabindex', on ? '0' : '-1');
        var p = panelFor(t);
        if (p) { p.hidden = !on; }
      });
      if (moveFocus) tab.focus();
    }

    Array.prototype.forEach.call(tabs, function (tab, i) {
      tab.addEventListener('click', function () { select(tab, false); });

      tab.addEventListener('keydown', function (e) {
        var next = null;
        switch (e.key) {
          case 'ArrowRight':
          case 'ArrowDown':
            next = tabs[(i + 1) % tabs.length];
            break;
          case 'ArrowLeft':
          case 'ArrowUp':
            next = tabs[(i - 1 + tabs.length) % tabs.length];
            break;
          case 'Home':
            next = tabs[0];
            break;
          case 'End':
            next = tabs[tabs.length - 1];
            break;
          default:
            return;
        }
        e.preventDefault();
        select(next, true);
      });
    });

    select(tabs[0], false);
  });
})();
